module.exports = __webpack_public_path__ + "static/media/icon-arrow-blue-down.065e1351.svg";